const LANGUAGE_PROFICIENCY_TITLE = {
    FULL_PROFESSIONAL: 'Full Professional',
    NATIVE_OR_BILINGUAL: 'Native or Bilingual',
    PROFESSIONAL_WORKING: 'Professional Working'
}
export const getProficiency = val => {
    return LANGUAGE_PROFICIENCY_TITLE[val] || val;
}

export const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];